module.exports = __webpack_public_path__ + "img/5.e54d4eb6.jpg";